<template>
  <div class="container">
    <section class="intro-single">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-8">
            <div class="title-single-box"><h1 class="title-single">Our People</h1>
              <span class="color-text-a">LASR Lab - Vanderbilt University Medical Center</span></div>
          </div>
          <div class="col-md-12 col-lg-4">
            <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/"
                                               class="router-link-active">Home</a></li>
                <li aria-current="page" class="breadcrumb-item active">
                  People
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section class="section-people">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-t3">
            <div class="row" v-for="p in people">
              <div class="col-md-2">
                <img :src="'/static/img/' + p.image" class="img-fluid lab-image"/></div>
              <div class="col-md-10 section-md-t3">
                <div class="title-box-d"><h3 class="title-d">{{p.name}}
                  <br><span class="color-d">{{p.title}}</span></h3></div>
                <p class="color-text-a text-justify" v-html="p.bio"></p></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-alumni">
      <div class="title-box-d"><h3 class="title-d">Lab Alumni</h3></div>
      <div class="container">
        <div class="row">
          <div class="col-md-3" v-for="p in alumni">
            <div class="row">
              <div class="col-md-12">
                <div class="box-small-person"><h4 class="title-d"><a

                  :href="p.link">{{p.name}}</a></h4>
                  <div class="color-c">{{p.position}}</div>
                  <div class="color-d">{{p.title}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "People",
    data: function () {
      return {
        people: [{
          name: "Carissa Cascio, Ph.D.",
          title: "Principal Investigator",
          image: "UNADJUSTEDNONRAW_thumb_2149-min.jpg",
          bio: "My graduate training was in neuroscience at Emory University. My work was centered on sensory neuroscience applied to human and nonhuman primates, with an emphasis on tactile perception and functional imaging. Having developed an interest in the neuroscience of autism, I pursued postdoctoral studies at the Neurodevelopmental Disorders Research Center at the University of North Carolina. There I focused dually on somatosensory processing in individuals with autism, and diffusion tensor imaging in young children with autism and other developmental disabilities. <br/> In 2007, I joined the Psychiatric Neuroimaging Program in Vanderbilt’s Department of Psychiatry. I hold a secondary appointment in the Department of Psychology and Human Development, and am affiliated with the Vanderbilt Kennedy Center, Vanderbilt Brain Institute, Center for Integrative and Cognitive Neuroscience, and Vanderbilt Vision Research Center. My lab focuses on the neural basis of sensory and repetitive behaviors in individuals with autism spectrum disorders."
        }, {
          name: "Alisa Zoltowski",
          title: "Graduate Student",
          image: "Alisa.jpg",
          bio: "Alisa Zoltowski is a Ph.D. student in the neuroscience program. She received a double B.S. in Biospsychology, Cognition, and Neuroscience (BCN), and Statistics from the University of Michigan and worked as a research assistant at the Children’s Hospital of Philadelphia’s Center for Autism Research before joining the lab. She is a triplet inspired by her brother with autism to better understand neural mechanisms of sensory processing differences in those with autism, particularly somatosensory, internal processing, and pain. Ultimately, she hopes that her research on these mechanisms will have translational potential to better inform treatments and supports for individuals with sensory processing difficulties."
        }, {
          name: "Jennifer Quinde",
          title: "Graduate Student",
          image: "Jenn-lndscp-min.jpeg",
          bio: "Jennifer Quinde is a Ph.D. student in Vanderbilt Brain Institute’s neuroscience program. Before joining the lab, she received a B.S. in Neuroscience from St. Lawrence University in Canton, New York. While in college, she worked as a teacher’s assistant for an applied behavioral analysis classroom of six children diagnosed with autism where she was first inspired to understand the neural systems involved in core autism symptomatology. Currently, she is interested in exploring how emotion processing differs in individuals with autism and how these differences affect empathetic responses."
        },{
          name: "Kacie Dunham",
          title: "Graduate Student",
          image: "Kacie.jpg",
          bio: "Kacie is a Ph.D. student in the Vanderbilt Brain Institute's Neuroscience Graduate Program. She received a B.A. in Neuroscience with a minor in Music from Vanderbilt University. Her research focuses on the developmental trajectory of sensory processing in autism with an emphasis on how the development of sensory processing may relate to autism symptomatology. She hopes her research on this trajectory will have translational potential to benefit diagnosis, treatment, and support for individuals with autism."
        }, {
          name: "Zack Williams",
          title: "Graduate Student",
          image: "Zack.jpg",
          bio: "Zack is a MD/PhD student at Vanderbilt. He received his B.S. in Psychology from Yale University, where he was heavily involved in autism research at the Yale Child Study Center. Zack is interested in the phenomenology of sensory abnormalities in autism and other neuropsychiatric disorders, particularly in adolescence and adulthood. Ultimately, he hopes to combine a number of behavioral, questionnaire, and neuroimaging methods to gain a richer understanding of individual differences in sensory function across traditional disorder categories."
        }, {
          name: "Kimberly Bress",
          title: "Graduate Student",
          image: "Kimmy.png",
          bio: "Kimberly (Kimmy) Bress is an MD-PhD student in the Vanderbilt Medical Scientist Training Program.   She received her B.A. in Neuroscience and Mental Health Studies from the University of Tennessee, after which she worked as a research assistant for the Queen Sofia Foundation of Spain and the National Institute of Child Health and Human Development.  She is interested in the application of neuroimaging methods to study the relationship between sensorimotor integration and compulsive behaviors in autism and other neuropsychiatric disorders."
        }, {
          name: "Brianna Lewis, Ph.D.",
          title: "Clinical Psychologist",
          image: "lewisb4_card.jpeg",
          bio: "Brianna received her Ph.D. in Clinical Psychology from Fordham University and then went on to complete her clinical internship and postdoctoral fellowship at the Yale Child Study Center specializing in the diagnostic evaluation, psychological assessment, and providing empirical interventions for children and adults with autism spectrum disorder. Following her postdoctoral fellowship, Brianna joined the faculty at the Yale Child Study Center. She was a clinical psychologist on a multi-disciplinary team in the Developmental Disabilities Clinic and as a clinician supporting various research studies investigating the neural markers of social processing in individuals with autism spectrum disorder across the lifespan, in addition to a multi-site study investigating potential biomarkers for autism spectrum disorder.  Her clinical interests additionally include psychological assessment, and school advocacy for children with mental health challenges, behavioral challenges, and/or developmental disabilities."
        }, {
          name: "Caitlin Convery",
          title: "Research Coordinator",
          image: "Caitlin.JPG",
          bio: "Caitlin graduated from the University of Pittsburgh in 2021 with a BPhil in Psychology. During her time at Pitt, she worked as a research assistant in the Kids' Thinking Lab for 3 years, where she investigated how young children differentially learn the foundations of math in their home environment. She was given the opportunity to start an independent project, which involved developing a novel behavioral coding scheme, and successfully defended her Bachelor of Philosophy honors thesis describing the results. For her next steps after graduation, she was interested in gaining more research experience and wanted to expand her research area to atypically developing populations. She is especially fascinated by the complexity of autism, since her older brother is on the spectrum. She is excited to be a part of research that will broaden our understanding of ASD symptomatology and potentially help improve the reliability of early identification measures. In the future, she plans on pursuing a graduate degree in developmental psychology, where she hopes to continue researching autism."
        }, {
          name: "Bahar Keceli-Kaysili, Ph.D.",
          title: "Research Coordinator",
          image: "Bahar.jpg",
          bio: "Bahar has extensive clinical experience working with young children with ASD, other intellectual and developmental disabilities and their families as special educator and as an academician. Regarding her educational background she possesses a doctoral degree in Special Education at the University of Ankara in Turkey in 2012. Her graduate work in special education aimed to understand the relationship of theory of mind and language in children with autism spectrum disorders. Her postdoctoral study focused on observational measurement of behavior, communication and language development, social interaction dynamics in prelinguistic period, educational interventions to promote communication and language in children with autism spectrum disorders."
        }, {
          name: "Maya Sachs",
          title: "Undergraduate Student",
          image: "Maya.jpg",
          bio: "Maya Sachs is an undergraduate student at Vanderbilt University, double majoring in Neuroscience and Medicine, Health, and Society. Her previous research focused on measuring healthcare worker’s ability to rate pain levels of those with autism. Her current research explores interoceptive performance before and after aerobic exercise. Maya plans to enter the healthcare profession and utilize her new understanding of autism to better care for autistic individuals."
        }, {
          name: "Sheila Akavan",
          title: "Undergraduate Student",
          image: "Sheila.jpg",
          bio: "I am currently an undergraduate student majoring in Medicine, Health, and Society and plan to attend medical school following graduation. I became particularly interested in autism spectrum disorder after volunteering in a program that provided an outlet for kids with special needs to take part in their community through participating in sporting games. This prompted me to learn more, which led me to writing a paper concerning the controversy of vaccination and whether it was linked to causing autism. I look forward to learning more about this disorder and will continue to help those affected and bring awareness to helping those in need. "
        }, {
          name: "Fiona Wu",
          title: "Undergraduate Student",
          image: "Fiona.jpg",
          bio: "Fiona is an undergraduate student at Vanderbilt majoring in Neuroscience and minoring in English. She is looking into the laminar thickness and gyrification of the fusiform gyrus area and their relations with the likelihood of autism in babies. Fiona plans to attend medical or graduate school to continue learning about the human brain after college.  "
        }, {
          name: "Eshani Arumalla",
          title: "Undergraduate Student",
          image: "Eshani.JPG",
          bio: "Eshani Arumalla is an undergraduate student at Vanderbilt University majoring in Neuroscience and minoring in Human and Organizational Development. Eshani became interested in learning more about Autism following her brother’s diagnosis. She has initiated numerous service and technical projects and written a meta-analysis analyzing the role of Autistic children on the Emotional Intelligence of their Parents. Eshani hopes to attend medical school in the future and continue working toward improving the lives of those on the spectrum."
        }, {
          name: "Emily Plump",
          title: "Undergraduate Student",
          image: "Emily P.JPG",
          bio: "Emily Plump is an undergraduate student at Vanderbilt University majoring in Neuroscience and minoring in Special Education. She has volunteered with programs that work with people with disabilities throughout her life, and has been continuing to do so in college. This is how she became interested in studying the neurological basis of Autism. Emily plans to attend medical school after college, continue to study the neurological basis of disorders, and ultimately help improve the lives of children with Autism."
        }, {
          name: "Emily Gothelf",
          title: "Undergraduate Student",
          image: "Emily G.jpg",
          bio: "I am a third-year Undergraduate student at Vanderbilt studying Special Education on the severe track and minoring in cognitive studies. I have been pursuing my interest in this field since middle school and have found that I am extremely passionate about my ability to connect with adolescents/adults on the Autism Spectrum. My passion for special education is rooted in my admiration for the autistic brain and the different ways they process the same experiences as the neurotypical brain. I have worked in a specialized classroom, creating and implementing a behavior intervention plan. For the past four summers, I have been working at a day camp for people with developmental disabilities. I completed SCIP-R training for my camp position to be more prepared to prevent crises. Being able to apply what I understand about neurodiverse brains to real-life situations is extremely rewarding. I expect that whatever I learn from my research experience to help provide a foundation for me to care for, teach, and work with individuals in my career."
        }],
        alumni: [{
          name: "Michelle Failla",
          link: "https://scholar.google.com/citations?user=P_oWfEgAAAAJ&hl=en",
          title: "Postdoctoral Research Fellow",
          position: "Research Assistant Professor at The Ohio State University College of Nursing"
        }, {
          name: "Jen Foss-Feig",
          link: "https://labs.icahn.mssm.edu/foss-feig-lab/",
          title: "Research Assistant",
          position: "Assistant Professor in Psychiatry at Ichan School of Medicine at Mount Sinai"
        }, {
          name: "Lauren Bryant",
          title: "Graduate Student",
          position: "Program Manager at Microsoft"
        },{
          name: "Ekomobong Eyoh",
          link: "https://www.linkedin.com/in/ekom-eyoh",
          title: "Research Coordinator",
          position: "Graduate Student at the University of Minnesota"
        }, {
          name: "Madison Gerdes",
          title: "Research Assistant",
          position: "Graduate Student at Northeastern University"
        }, {
          name: "Alan Faulks",
          title: "Graduate Student",
          position: null

        }, {
          name: "Neeti Gandra",
          title: "Undergraduate Student",
          position: "Medical Student"
        }, {
          name: "Molly Sullivan",
          title: "Undergraduate Student",
          position: "Family Nurse Practitioner Student at Vanderbilt University School of Nursing"
        }, {
          name: "Payton DePalma",
          title: "Undergraduate Student",
          position: "Project Manager at EPIC"
        }, {
          name: "Kyle Schwartz",
          title: "Undergraduate Student",
          position: "Medical Student at Vanderbilt University School of Medicine"
        }, {
          name: "Heayeon Kim",
          title: "Undergraduate Student",
          position: null
        }, {
          name: "Ashley Augustine",
          title: "Undergraduate Student",
          position: null
        }, {
          name: "Emily Alpin",
          title: "Undergraduate Student",
          position: null
        }, {
          name: "Samona Davis",
          title: "Research Analyst",
          position: null
        }, {
          name: "Miller Tracy",
          title: "Research Assistant",
          position: "Data Science, Seattle, Washington"
        }, {
          name: "Brynna Helfin",
          title: "Research Assistant",
          position: "Graduate student in Clinical Psychology, Florida International University"
        }, {
          name: "Lisa Mash",
          title: "Research Assistant",
          position: "Graduate student in Clinical Psychology, San Diego State University/UC San Diego Joint Program"
        }, {
          name: "Jennifer Pryweller",
          title: "Graduate Student Affiliate",
          position: "Postdoctoral Research Associate at St. Jude Children's Research Hospital"
        }, {
          name: "Kim Schauder",
          title: "Research Assistant",
          position: "Graduate student in Clinical Psychology, University of Rochester"
        }, {
          name: "Jessica Heacock",
          title: "Research Assistant",
          position: "Board-certified behavior analyst (BCBA), Metro Nashville Public Schools"
        }, {
          name: "Scott Bolton",
          title: "Medical Student (Emphasis Program)",
          position: "Resident in Pediatrics, Cincinnati Children's Hospital"
        }, {
          name: "Akua Cosby",
          title: "Research Assistant",
          position: "Graduate student in Counseling, Texas Woman's University"
        }]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/People.vue